import { useSafeState } from '#hooks';
import { ComposeNotificationV3 } from '#notifications/components/composeNotificationV3.component';
import { UserV3 } from '#types';
import { FC } from 'react';

interface UserNotificationV3Props {
    user: UserV3;
}

export const UserNotificationV3: FC<UserNotificationV3Props> = ({ user }) => {

    const [showSendNotification, setShowSendNotification] = useSafeState<boolean>(false)
    const [isConfirmationOpen, setIsConfirmationOpen] = useSafeState<boolean>(false)

    return <div className="main-dashboard-container pd-m">
        <div className='three-columns-expand-two'>
            <p className='vertical-align'>Send {user.firstName || ''} a notification</p>
            <div />
            <div className='two-columns-expand-one'>
                <div />
                <button className='clear-button' id='expand-contract-button' onClick={() => setShowSendNotification(!showSendNotification)}>
                    <img src={showSendNotification ? "/images/contract.png" : "/images/expand.png"} alt="expand-contract" className='expand-contract-esim' />
                </button>
            </div>
        </div>
        {showSendNotification && <ComposeNotificationV3 isConfirmationOpen={isConfirmationOpen} setIsConfirmationOpen={setIsConfirmationOpen} userID={user.id} />}
    </div>
}
